import { StyledCol, StyledInput, StyledRow, StyledSelect, StyledTextArea } from '@/shared/styles';
import { StyledLabel } from '../Forms.styles';
import { Form } from 'antd';
import { GradientBorderButton } from '@/shared/components/Button/GradientBorderButton';
import { U1Button } from '@/shared/components/Button/U1Button';
import { useTranslation } from 'react-i18next';
import {
  TrustedSourceType,
  trustedSourceTypeTitles,
} from '@/stores/TrustedSourceStore/TrustedSourceStore.consts';
import { DatepickerSingleInput } from '../../Datepicker/DatepickerSingleInput';
import { TrustedSourceInnerFormProps } from './TrustedSourceForm.consts';
import { formatDateFromTimestamp } from '@/shared/utils/datepicker';

export const TrustedSourceInnerForm: React.FC<TrustedSourceInnerFormProps> = ({
  selected,
  onValuesChange,
  onCancel,
  submitBtnText,
}: TrustedSourceInnerFormProps) => {
  const { t } = useTranslation();

  const onSingleDateSelect = (date: string) => {
    onValuesChange({ expiredAt: new Date(date).getTime() });
  };

  return (
    <>
      <StyledCol $justify="center" $width="100%" $gap={8}>
        <StyledLabel>{t('admin.table.type')}*</StyledLabel>
        <Form.Item
          name="type"
          rules={[
            {
              required: true,
              message: `${t('admin.table.type')} ${t('form.required')}`,
            },
          ]}
        >
          <StyledSelect
            placeholder={t('admin.form.select')}
            options={Object.values(TrustedSourceType).map((type) => ({
              label: trustedSourceTypeTitles[type],
              value: type,
            }))}
          />
        </Form.Item>

        <StyledLabel>{t('admin.table.value')}*</StyledLabel>
        <Form.Item
          name="value"
          rules={[
            {
              required: true,
              message: `${t('admin.table.value')} ${t('form.required')}`,
            },
          ]}
        >
          <StyledInput placeholder={t('admin.table.value')} />
        </Form.Item>

        <StyledLabel>{t('admin.table.exprired_at')}</StyledLabel>
        <Form.Item name="expiredAt">
          <DatepickerSingleInput
            presetValue={
              selected?.expiredAt ? formatDateFromTimestamp(selected?.expiredAt) : undefined
            }
            onSelect={onSingleDateSelect}
          />
        </Form.Item>

        <StyledLabel>{t('admin.table.comment')}</StyledLabel>
        <Form.Item name="comment">
          <StyledTextArea data-testid="messageField" placeholder={t('admin.table.comment')} />
        </Form.Item>
      </StyledCol>

      <StyledRow $justify="space-between" $width="100%" $gap={24}>
        <Form.Item>
          <GradientBorderButton
            text={t('cancel')}
            $height="50px"
            $width="100%"
            onClick={(e: Event) => onCancel(e)}
          />
        </Form.Item>
        <Form.Item>
          <U1Button text={submitBtnText ?? t('save_changes')} htmlType="submit" />
        </Form.Item>
      </StyledRow>
    </>
  );
};
